import React from "react";

import { FormCheckbox } from "../../../forms/FormCheckbox";
import { IFormUUID } from "../../../models/nominals";
import { IWriteReviewTemplateField } from "../../../models/reviews";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { reviewFormCheckboxChange } from "../reducers";
import { getWriteReviewFormState } from "../selectors";

export const WriteReviewFormCheckboxField = (props: {
    formUUID: IFormUUID;
    name: string;
    field: IWriteReviewTemplateField;
}): React.ReactNode => {
    const dispatch = useAppDispatch();

    const formState = useAppSelector((rootState) =>
        getWriteReviewFormState(rootState.reviews, props),
    );
    const values = formState.valuesMultiSelect[props.name] ?? [];
    const errors = formState.errors[props.name] ?? [];
    const showErrors = formState.showErrors;

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        dispatch(
            reviewFormCheckboxChange({
                formUUID: props.formUUID,
                fieldName: props.name,
                fieldValue: e.currentTarget.value,
                isChecked: e.currentTarget.checked,
            }),
        );
    };

    const inputs = props.field.options.map((option) => {
        return (
            <FormCheckbox
                key={option}
                name={`${props.name}-${props.formUUID}`}
                required={props.field.is_required}
                label={option}
                labelPlacement={"static"}
                value={option}
                errors={errors}
                showErrorMessages={showErrors}
                checked={values.includes(option)}
                onChange={onChange}
            />
        );
    });

    return (
        <fieldset>
            <legend>{props.field.name}</legend>
            {inputs}
        </fieldset>
    );
};
